module.exports = __webpack_public_path__ + "static/media/trump-johnson-trudeau-versus-health-subjectivity.335ff28a.png";